import React, { Component } from 'react';

import './Division.css';

class Division extends Component {

    render() {
        return (
            <svg className={this.getClass()} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'>
                {
                    this.getPolygon()
                }
            </svg>
        );
    }

    getClass() {

        const position = this.props.invert ? 'top' : 'bottom';

        return this.props.block ? `division block ${position}` : `division ${position}`;
    }

    getPolygon() {
        return <polygon
            fill={
                this.props.color
            }
            points={
                this.getPoints()
            } />;
    }

    getPoints() {

        const corner = this.props.invert ? '0,0' : '100,100';

        return `${corner} 0,100 100,0`;
    }

}

export default Division;